import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/logo.jpg';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const [dropdownTimeout, setDropdownTimeout] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleDropdownEnter = () => {
    if (dropdownTimeout) {
      clearTimeout(dropdownTimeout);
      setDropdownTimeout(null);
    }
    setIsServicesDropdownOpen(true);
  };

  const handleDropdownLeave = () => {
    const timeout = setTimeout(() => {
      setIsServicesDropdownOpen(false);
    }, 300); // 300ms delay before closing
    setDropdownTimeout(timeout);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="main-header">
        <div className="container">
          <div className="main-header-content">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt="Tea Gardens Healthcare" className="logo-img" />
              </Link>
            </div>
            
            <div className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
              <span></span>
              <span></span>
              <span></span>
            </div>
            
            <nav className={`main-nav ${isMobileMenuOpen ? 'open' : ''}`}>
              <ul>
                <li>
                  <NavLink to="/" end onClick={closeMobileMenu}>Home</NavLink>
                </li>
                <li>
                  <NavLink to="/about" onClick={closeMobileMenu}>About Us</NavLink>
                </li>
                <li>
                  <NavLink to="/doctors" onClick={closeMobileMenu}>Our Team</NavLink>
                </li>
                <li 
                  className="services-dropdown"
                  onMouseEnter={handleDropdownEnter}
                  onMouseLeave={handleDropdownLeave}
                >
                  <NavLink to="/services" onClick={closeMobileMenu}>Services</NavLink>
                  <div 
                    className={`dropdown-menu ${isServicesDropdownOpen ? 'show' : ''}`}
                    onMouseEnter={handleDropdownEnter}
                    onMouseLeave={handleDropdownLeave}
                  >
                    <Link to="/services/skin-cancer-check" onClick={closeMobileMenu}>Skin Cancer Check</Link>
                    {/* <Link to="/services/alternative-medicine" onClick={closeMobileMenu}>Alternative Medicine</Link> */}
                    <Link to="/services/disease-management-program" onClick={closeMobileMenu}>Disease Management Program</Link>
                    <Link to="/services/kids-health" onClick={closeMobileMenu}>Kid's Health</Link>
                    <Link to="/services/mens-wellness-care" onClick={closeMobileMenu}>Men's Wellness Care</Link>
                    <Link to="/services/primary-care-services" onClick={closeMobileMenu}>Primary Care Services</Link>
                    <Link to="/services/womens-medical-care" onClick={closeMobileMenu}>Women's Medical Care</Link>
                    <Link to="/services/comprehensive-health-checks" onClick={closeMobileMenu}>Comprehensive Health Checks</Link>
                  </div>
                </li>
                <li>
                  <NavLink to="/after-hours" onClick={closeMobileMenu}>After-Hours Care</NavLink>
                </li>
                <li>
                  <NavLink to="/bulk-billing" onClick={closeMobileMenu}>Bulk Billing</NavLink>
                </li>
                <li>
                  <NavLink to="/blog" onClick={closeMobileMenu}>Blog</NavLink>
                </li>
                <li>
                  <NavLink to="/contact" onClick={closeMobileMenu}>Contact</NavLink>
                </li>
                <li className="mobile-appointment-btn">
                  <Link to="https://www.hotdoc.com.au/medical-centres/tea-gardens-NSW-2324/tea-gardens-gp/doctors" onClick={closeMobileMenu} className="mobile-book-btn">
                    <FontAwesomeIcon icon={faPhone} /> Book Appointment
                  </Link>
                </li>
              </ul>
            </nav>
            
            <div className="header-right">
              <div className="contact-info">
                <a href="tel:+61249501333">
                  <FontAwesomeIcon icon={faPhone} /> +61 2 4950 1333
                </a>
              </div>
              <Link to="https://www.hotdoc.com.au/medical-centres/tea-gardens-NSW-2324/tea-gardens-gp/doctors" className="appointment-btn">Book Appointment</Link>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
